import {
	SP_ORDERS_LOCATION4_LIST_FILTERED,
	SP_ORDERS_LOCATION4_LIST_FILTERED_SUCCESS,
	SP_ORDERS_LOCATION4_LIST_FILTERED_ERROR,
	SP_ORDERS_LOCATION4_IMPORT,
	SP_ORDERS_LOCATION4_IMPORT_SUCCESS,
	SP_ORDERS_LOCATION4_IMPORT_ERROR,
	SP_ORDERS_LOCATION4_CREATE,
	SP_ORDERS_LOCATION4_CREATE_SUCCESS,
	SP_ORDERS_LOCATION4_CREATE_ERROR,
	SP_ORDERS_LOCATION4_DELETE,
	SP_ORDERS_LOCATION4_DELETE_SUCCESS,
	SP_ORDERS_LOCATION4_DELETE_ERROR,
	SP_ORDERS_LOCATION4_ADD_COMMENT,
	SP_ORDERS_LOCATION4_ADD_COMMENT_SUCCESS,
	SP_ORDERS_LOCATION4_ADD_COMMENT_ERROR,
} from "../actions/spOrdersLocation4";
import SpOrdersLocation4Service from '@/services/spOrdersLocation4';

const state = {
	status: ''
};

const getters = {
};

const actions = {
	[SP_ORDERS_LOCATION4_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		
		// Add filters if they exist
		if (data.tableProps.inputFilter.brand_code) {
			requestData.brandCodeFilter = data.tableProps.inputFilter.brand_code;
		}
		if (data.tableProps.inputFilter.part_number) {
			requestData.partNumberFilter = data.tableProps.inputFilter.part_number;
		}
		if (data.tableProps.inputFilter.description) {
			requestData.descriptionFilter = data.tableProps.inputFilter.description;
		}
		if (data.tableProps.inputFilter.main_location) {
			requestData.mainLocationFilter = data.tableProps.inputFilter.main_location;
		}
		if (data.tableProps.inputFilter.parts_group) {
			requestData.partsGroupFilter = data.tableProps.inputFilter.parts_group;
		}

		return new Promise((resolve, reject) => {
			commit(SP_ORDERS_LOCATION4_LIST_FILTERED);
			SpOrdersLocation4Service.listFiltered(requestData)
				.then(responseData => {
					commit(SP_ORDERS_LOCATION4_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(SP_ORDERS_LOCATION4_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	},
	[SP_ORDERS_LOCATION4_IMPORT]: ({ commit }, formData) => {
		return new Promise((resolve, reject) => {
			commit(SP_ORDERS_LOCATION4_IMPORT);
			SpOrdersLocation4Service.import(formData)
				.then(responseData => {
					commit(SP_ORDERS_LOCATION4_IMPORT_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(SP_ORDERS_LOCATION4_IMPORT_ERROR, error);
					reject(error);
				});
		});
	},
	[SP_ORDERS_LOCATION4_CREATE]: ({ commit }, data) => {
		return new Promise((resolve, reject) => {
			commit(SP_ORDERS_LOCATION4_CREATE);
			SpOrdersLocation4Service.create(data.item)
				.then(responseData => {
					commit(SP_ORDERS_LOCATION4_CREATE_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(SP_ORDERS_LOCATION4_CREATE_ERROR, error);
					reject(error);
				});
		});
	},
	[SP_ORDERS_LOCATION4_DELETE]: ({ commit }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(SP_ORDERS_LOCATION4_DELETE);
			SpOrdersLocation4Service.delete(requestData)
				.then(responseData => {
					commit(SP_ORDERS_LOCATION4_DELETE_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(SP_ORDERS_LOCATION4_DELETE_ERROR, error);
					reject(error);
				});
		});
	},
	[SP_ORDERS_LOCATION4_ADD_COMMENT]: ({ commit }, data) => {
		let requestData = {
			id: data.id,
			comment: data.comment
		}
		return new Promise((resolve, reject) => {
			commit(SP_ORDERS_LOCATION4_ADD_COMMENT);
			SpOrdersLocation4Service.addComment(requestData)
				.then(responseData => {
					commit(SP_ORDERS_LOCATION4_ADD_COMMENT_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(SP_ORDERS_LOCATION4_ADD_COMMENT_ERROR, error);
					reject(error);
				});
		});
	}
};

const mutations = {
	[SP_ORDERS_LOCATION4_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[SP_ORDERS_LOCATION4_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDERS_LOCATION4_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	},

	[SP_ORDERS_LOCATION4_IMPORT]: state => {
		state.status = 'loading';
	},
	[SP_ORDERS_LOCATION4_IMPORT_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDERS_LOCATION4_IMPORT_ERROR]: state => {
		state.status = 'error';
	},

	[SP_ORDERS_LOCATION4_CREATE]: state => {
		state.status = 'loading';
	},
	[SP_ORDERS_LOCATION4_CREATE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDERS_LOCATION4_CREATE_ERROR]: state => {
		state.status = 'error';
	},

	[SP_ORDERS_LOCATION4_DELETE]: state => {
		state.status = 'loading';
	},
	[SP_ORDERS_LOCATION4_DELETE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDERS_LOCATION4_DELETE_ERROR]: state => {
		state.status = 'error';
	},
	[SP_ORDERS_LOCATION4_ADD_COMMENT]: state => {
		state.status = 'loading';
	},
	[SP_ORDERS_LOCATION4_ADD_COMMENT_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDERS_LOCATION4_ADD_COMMENT_ERROR]: state => {
		state.status = 'error';
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};